import { Main, ViewButton } from 'components/ActionStyles/ActionStyles'
import React from 'react'
import { useNavigate } from 'react-router'

const DriveActonInfo = ({ drive }) => {
  const navigate = useNavigate()
  const handleDriveInfo = () => {
    navigate(`/expcandidates/${drive?.driveId}/role/${drive?.roleId}`)
  }

  return (
    <Main>
      <ViewButton onClick={handleDriveInfo} height="32px" text={'Drive Info'} />
    </Main>
  )
}

export default DriveActonInfo
